export default [
  'Мф.',
  'Мк.',
  'Лк.',
  'Ин.',
  'Деян.',
  'Иак.',
  '1_Пет.',
  '2_Пет.',
  '1_Ин.',
  '2_Ин.',
  '3_Ин.',
  'Иуд.',
  'Рим.',
  '1_Кор.',
  '2_Кор.',
  'Гал.',
  'Еф.',
  'Флп.',
  'Кол.',
  '1_Сол.',
  '2_Сол.',
  '1_Тим.',
  '2_Тим.',
  'Тит.',
  'Флм.',
  'Евр.',
  'Иез.',
  'Зах.',
  'Иоил.',
  'Прем._Солом.',
  'Ис.',
  'Иcх.',
  'Быт.',
  'Притч.',
  'Мал.'
]
